import { useEffect, useState } from "react"
import Menu from "../../components/menu"
import useAuth from "../../hooks/useAuth"
import { authApi } from "../../services/api/api"
import Book from "../../components/book"


import { useInfiniteQuery } from '@tanstack/react-query'

import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import { useLocation } from "react-router-dom"
import SkeletonBiblioteca from "../../components/skeletons/biblioteca"
import MenuBookIcon from '@mui/icons-material/MenuBook';

import { useInView } from 'react-intersection-observer';

import imgLivros from '../../assets/images/livros.png';
import ScrollToTop from "../../components/scrollToTop"

export default function Biblioteca() {

    const { ref, inView } = useInView();

    const resquestRedirect = useLocation()

    const [atualizar, setAtualizar] = useState(false)
    const numberOfSkeletons = 12; // Define o número de esqueletos para o carregamento inicial

    const initialSkeletons = Array.from({ length: numberOfSkeletons }, (_, index) => (
        <SkeletonBiblioteca key={index} />
    ));

    const api = authApi()

    const [search, setSearch] = useState(resquestRedirect.state ?? '')

    const [order, setOrder] = useState('')

    const [gen, setGen] = useState('')

    const [letra, setLetra] = useState('')

    const [lastPage, setlastPage] = useState(false)

    const [likes, setLikes] = useState('')

    const { user, theme } = useAuth()

    const [open, setOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState(resquestRedirect.state ?? '');

    const status = 0
    // Função de disparo
    const handleSearch = () => {
        setSearchTerm(search); // Se estiver vazio, ele limpa a busca na API
        setAtualizar(prev => !prev);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {

            handleSearch();
        }
    };
    const handleClickOpen = async () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = async () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const getData = async ({ pageParam = 1 }) => {
        // Note que agora passamos diretamente o número da página
        const data = await api.list(pageParam, searchTerm, order, gen, letra, likes, status);
        return data;
    };


    // No seu componente Biblioteca
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
        // Adicione 'status' aqui na queryKey para evitar conflitos de cache
        queryKey: ['books', searchTerm, order, gen, atualizar, letra, likes, status],
        queryFn: getData,
        initialPageParam: 1,
        getNextPageParam: (lastPage) => {
            if (lastPage.current_page < lastPage.last_page) {
                return lastPage.current_page + 1;
            }
            return undefined;
        }
    });

    const pageSize = data?.pages[0]?.data?.length || 8;

    const paginationSkeletons = Array.from({ length: pageSize }, (_, index) => (
        <SkeletonBiblioteca key={`pagination-skeleton-${index}`} />
    ));
    function handleOrder(e: any) {
        if (e.target.value !== '') {
            setOrder(e.target.value)
        }
    }

    useEffect(() => {
        if (inView && hasNextPage && !isFetchingNextPage) {
            fetchNextPage();
        }
    }, [inView, hasNextPage, isFetchingNextPage]);

    // Verifica se algum filtro (busca, gênero, letra, ordem ou curtidas) foi alterado
    const isFiltered =
        searchTerm !== '' ||
        gen !== '' && gen !== 'todos' ||
        letra !== '' ||
        order !== '' ||
        likes !== '';

    const handleClear = () => {
        // Limpa os estados de busca
        setSearch('');
        setSearchTerm('');

        // Reseta os filtros para os valores iniciais/vazios
        setOrder('');
        setGen('todos'); // Ou '' dependendo de como seu backend trata
        setLetra('');
        setLikes('');

        // Opcional: força uma atualização manual se necessário
        setAtualizar(prev => !prev);
    };

    const EmptyState = ({ searchTerm, onClear }: { searchTerm: string, onClear: () => void }) => (
        <div className="flex flex-col items-center justify-center py-24 text-center animate-in fade-in duration-700 col-span-full">
            <div className="bg-blue-50 dark:bg-blue-900/20 p-8 rounded-full mb-6 shadow-inner">
                <MenuBookIcon sx={{ fontSize: 70, color: '#195AB4' }} className="opacity-40" />
            </div>
            <h2 className="text-2xl font-light text-gray-800 dark:text-gray-100 tracking-tight">
                Nenhum capítulo encontrado
            </h2>
            <p className="text-gray-500 dark:text-gray-400 mt-3 max-w-sm text-sm leading-relaxed">
                Não encontramos resultados para <span className="text-blue-600 font-semibold">"{searchTerm}"</span>.
                Tente mudar os filtros ou verificar a ortografia.
            </p>
            <button
                onClick={onClear}
                className="mt-8 px-6 py-2 border border-blue-200 dark:border-blue-800 text-blue-600 dark:text-blue-400 rounded-full text-sm font-medium hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all active:scale-95"
            >
                Limpar filtros e voltar
            </button>
        </div>
    );

    return (
        <div className={`w-screen min-h-screen bg-white ${theme}`}>
            <Menu />

            <div className={`w-full flex flex-col items-center justify-center dark:bg-[#061c3f] bg-gray-50 min-h-screen  `}>
                <div
                    className="w-full h-[55vh] relative flex flex-col justify-center items-center px-6 overflow-hidden bg-blue3"
                    style={{
                        backgroundImage: `linear-gradient(to bottom, rgba(0, 25, 75, 0.6), rgba(0, 15, 50, 0.9)), url(${imgLivros})`,
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    {/* Conteúdo Centralizado e Compacto */}
                    <div className="z-10 w-full max-w-2xl flex flex-col items-center">

                        <div className="text-center mb-8">
                            <h1 className="text-2xl md:text-3xl font-light text-white tracking-widest uppercase mb-1 opacity-90">
                                Biblioteca <span className="font-semibold text-blue-500">Acreditar</span>
                            </h1>
                            <p className="text-gray-300 text-sm italic tracking-wide">Encontre seu próximo capítulo</p>
                        </div>

                        {/* Barra de Pesquisa Centralizada e Slim */}
                        <div className="w-full bg-white/5 backdrop-blur-xl p-2 rounded-full shadow-2xl border border-white/10 hover:border-white/20 transition-all flex items-center gap-1">

                            {/* Input de Texto (Menor e mais discreto) */}
                            <div className="flex-1 flex items-center gap-3  rounded-full px-2">
                                <div className=" text-white/30">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>
                                <input
                                    type="text"
                                    value={search} onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Autor, Título ou Palavra-chave..."
                                    className="flex-1 h-9 border-none bg-transparent focus:outline-none focus:ring-0 text-white placeholder-white/50 text-xs md:text-sm tracking-wide"
                                    onKeyDown={handleKeyDown}
                                />
                            </div>

                            {/* Botão Compacto e Moderno */}
                            <button
                                onClick={handleSearch}
                                className="h-9 px-4 bg-blue-600  hover:bg-blue-700 text-white font-semibold rounded-full text-xs md:text-sm transition-all shadow active:scale-95 tracking-wide flex items-center gap-1.5"
                            >

                                Buscar
                            </button>
                            {/* Botão de Limpar */}
                            {/* Botão de Limpar (Aparece condicionalmente) */}
                            {isFiltered && (
                                <button
                                    onClick={handleClear}
                                    className="h-9 px-4 text-white/70 hover:text-white text-xs font-medium transition-all animate-in fade-in zoom-in duration-300"
                                >
                                    Limpar Filtros
                                </button>
                            )}
                        </div>

                        {/* Filtros ainda mais discretos e integrados (Labels pequenos e Selects sem fundo) */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-2 mt-5 w-full max-w-xl px-2">

                            <div className="flex flex-col">
                                <label className="text-white/60 text-[9px] uppercase font-bold tracking-widest mb-0.5 ml-1 text-start">Gênero</label>
                                <select
                                    onChange={(e) => setGen(e.target.value)}
                                    className="bg-transparent border border-white/10 text-white text-xs p-1.5 focus:ring-0 cursor-pointer hover:text-blue-200 transition-colors h-8 rounded-lg"
                                >
                                    <option value="todos" className="text-blue-950 italic">Todos</option>
                                    <option value="Ação e aventura" className="text-blue-950">Ação e aventura</option>
                                    <option value="Auto Ajuda" className="text-blue-950">Auto Ajuda</option>
                                    <option value="Arte e Fotografia" className="text-blue-950">Arte e Fotografia</option>
                                    <option value="Auto Biografia" className="text-blue-950">Auto Biografia</option>
                                    <option value="Biografia" className="text-blue-950">Biografia</option>
                                    <option value="Conto" className="text-blue-950">Conto</option>
                                    <option value="Fantasia" className="text-blue-950">Fantasia</option>
                                    <option value="Fábula" className="text-blue-950">Fábula</option>
                                    <option value="Ficção Científica" className="text-blue-950">Ficção Científica</option>
                                    <option value="Horror" className="text-blue-950">Horror</option>
                                    <option value="Romance" className="text-blue-950">Romance</option>
                                    <option value="Infantil" className="text-blue-950">Infantil</option>
                                    <option value="História" className="text-blue-950">História</option>
                                    <option value="Humor" className="text-blue-950">Humor</option>
                                    <option value="Religião e Espiritualidade" className="text-blue-950">Religião e Espiritualidade</option>
                                    <option value="Ciências Sociais" className="text-blue-950">Ciências Sociais</option>
                                    <option value="Tecnologia e Ciência" className="text-blue-950">Tecnologia e Ciência</option>
                                    <option value="Negócios" className="text-blue-950">Negócios</option>
                                    {/* ... */}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="text-white/60 text-[9px] uppercase font-bold tracking-widest mb-0.5 ml-1 text-start">Ordem</label>
                                <select
                                    value={order}
                                    onChange={(e) => setOrder(e.target.value)}
                                    className="bg-transparent border border-white/10 text-white text-xs p-1.5 focus:ring-0 cursor-pointer hover:text-blue-200 transition-colors h-8 rounded-lg"
                                >
                                    <option value="" className="text-blue-950 italic">Padrão</option>
                                    <option value="ASC" className="text-blue-950">A-Z</option>
                                    <option value="DESC" className="text-blue-950">Z-A</option>
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="text-white/60 text-[9px] uppercase font-bold tracking-widest mb-0.5 ml-1 text-start">Inicial</label>
                                <select
                                    value={letra}
                                    onChange={(e) => setLetra(e.target.value)}
                                    className="bg-transparent border border-white/10 text-white text-xs p-1.5 focus:ring-0 cursor-pointer hover:text-blue-200 transition-colors h-8 rounded-lg"
                                >
                                    <option value="" className="text-blue-950 italic">Todas</option>
                                    {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map(l => (
                                        <option key={l} value={l} className="text-blue-950">{l}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="text-white/60 text-[9px] uppercase font-bold tracking-widest mb-0.5 ml-1 text-start">Curtidas</label>
                                <select
                                    value={likes}
                                    onChange={(e) => setLikes(e.target.value)}
                                    className="bg-transparent border border-white/10 text-white text-xs p-1.5 focus:ring-0 cursor-pointer hover:text-blue-200 transition-colors h-8 rounded-lg"
                                >
                                    <option value="" className="text-blue-950 italic">Populares</option>
                                    <option value="DESC" className="text-blue-950">Mais</option>
                                    <option value="ASC" className="text-blue-950">Menos</option>
                                </select>
                            </div>

                        </div>
                    </div>

                    {/* Gradiente de transição para o conteúdo abaixo (Ajuste para dark/light) */}
                    <div className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-t from-[#004b7a] via-[#002f4d] to-blue-[#2C6F99] opacity-80"></div>
                </div>


                <div className="lg:max-w-[1700px] pt-8 lg:pt-12 min-h-[430px] md:max-w-2xl sm:max-w-lg lg:px-0">


                    <div className="w-full flex gap-4 justify-center px-2 lg:px-0 items-center flex-col">

                        {/* <button onClick={handleClickOpen1} className={`${styles.hiddenBtn} p-1 bg-blue-900 text-white rounded-lg px-4 m-2`}>Filtro</button> */}
                        {/* <SkeletonBiblioteca /> */}
                        {/* <div className="grid 2xl:grid-cols-5 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-6 mt-6">
                            {paginationSkeletons}
                        </div> */}


                        <div className="grid 2xl:grid-cols-8 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-2 md:gap-6 gap-4 xs:px-2 lg:px-0">
                            {!data?.pages ? (
                                initialSkeletons
                            ) : data.pages[0].data.length === 0 ? (
                                <EmptyState
                                    searchTerm={searchTerm}
                                    onClear={() => {
                                        setSearch('');
                                        setSearchTerm('');
                                        setGen('todos');
                                        setLetra('');
                                        setOrder('');
                                        setLikes('');
                                    }}
                                />
                            ) : (
                                <>
                                    {/* Renderiza as páginas de livros já carregadas */}
                                    {data.pages.map((page) =>
                                        page.data.map((item, i) => <Book key={item.id} data={item} index={i} />)
                                    )}

                                    {/* Renderiza os skeletons DA PRÓXIMA PÁGINA dentro do mesmo grid */}
                                    {isFetchingNextPage && paginationSkeletons}
                                </>
                            )}
                        </div>

                        {/* Lógica para a paginação: exibe skeletons fora do grid principal de livros */}
                        {isFetchingNextPage && (
                            <div className="grid 2xl:grid-cols-8 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-6 mt-6">
                                {paginationSkeletons}
                            </div>
                        )}

                        <div className="flex justify-center mt-8">
                            <button ref={ref} onClick={() => fetchNextPage()} disabled={lastPage}></button>
                        </div>
                        <ScrollToTop />

                    </div>
                </div>



            </div>
            <ToastContainer />

            <div className="w-full h-1 dark:bg-slate-800"></div>
            {/* <Footer/> */}
            {/* <button onClick={handleClickOpen} className="text-blue-700 dark:text-white fixed bottom-5 right-5 border-2 rounded p-1 flex justify-center items-center border-blue-700 dark:border-white" title="Me indique um livro">
                <MenuBookIcon  fontSize="large"/>
            </button> */}
            {/* <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Me indique um livro!"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <div className="flex flex-col">
                            <Button autoFocus onClick={handleChatGpt}>
                                Com base nas minhas escolhas
                            </Button>
                            <div className="w-full">
                                <textarea className="w-full border rounded"></textarea>
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus>
                        Buscar
                    </Button>
                    <Button onClick={handleClose} color="error" autoFocus>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog> */}

        </div>
    )
}